let mintedThisVisit = false

const listeners = new Set<() => void>()

export const markRememberMeMinted = (): void => {
  mintedThisVisit = true
  listeners.forEach((listener) => listener())
}

export const consumeRememberMeMinted = (): boolean => {
  if (mintedThisVisit) {
    mintedThisVisit = false
    return true
  }
  return false
}

export const subscribeRememberMeMinted = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
